module.exports = __webpack_public_path__ + "img/png_jsgzl_2@2x.90c09e8b.png";